import { render } from "./PdfViewer.vue.js?vue&type=template&id=f9c3e89f!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./PdfViewer.vue?vue&type=template&id=f9c3e89f"
import script from "./PdfViewer.vue.js?vue&type=script&lang=js!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./PdfViewer.vue?vue&type=script&lang=js"
export * from "./PdfViewer.vue.js?vue&type=script&lang=js!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./PdfViewer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"public/assets/youthletics/components/PdfViewer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f9c3e89f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f9c3e89f', __exports__)) {
    api.reload('f9c3e89f', __exports__)
  }
  
  module.hot.accept("./PdfViewer.vue.js?vue&type=template&id=f9c3e89f!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./PdfViewer.vue?vue&type=template&id=f9c3e89f", () => {
    api.rerender('f9c3e89f', render)
  })

}


export default __exports__